"use client";

import { useReportWebVitals } from "next/web-vitals";
import posthog from "posthog-js";

/**
 * Web Vitals reporter (cf SEO audit 2026-05-07 P2-13).
 *
 * Collecte RUM (Real User Monitoring) des métriques Core Web Vitals — LCP,
 * INP, CLS, FCP, TTFB — depuis le navigateur des utilisateurs réels et les
 * envoie à PostHog. Permet de mesurer le terrain (= proxy CrUX) sans
 * dépendre uniquement du Lighthouse lab synthetic.
 *
 * PostHog rationale : déjà intégré, persistance localStorage+cookie. La CrUX
 * API officielle nécessite une API key payante ; PostHog offre la même
 * collecte avec dashboarding via les Insights.
 *
 * Schema event PostHog :
 *   - event_name: "web_vitals"
 *   - properties: { metric, value, rating, navigationType, page_url }
 *
 * Exploitation : créer un dashboard PostHog avec p75 par metric et par
 * type de page (home, fiche médecin, listing, article).
 */

type WebVitalMetric = {
  id: string;
  name: "LCP" | "INP" | "CLS" | "FCP" | "TTFB";
  value: number;
  rating?: "good" | "needs-improvement" | "poor";
  navigationType?: string;
};

export function WebVitalsReporter() {
  useReportWebVitals((metric: WebVitalMetric) => {
    // Évite de capturer si PostHog n'est pas chargé (admin host, dev sans key).
    if (typeof window === "undefined" || !posthog || !posthog.__loaded) return;
    try {
      posthog.capture("web_vitals", {
        metric: metric.name,
        // CLS exprimé en milliers de fois pour stocker des integers en BDD PostHog.
        value: metric.name === "CLS" ? Math.round(metric.value * 1000) : Math.round(metric.value),
        rating: metric.rating,
        navigation_type: metric.navigationType,
        page_path: window.location.pathname,
      });
    } catch {
      // ignore — RUM ne doit jamais bloquer le rendu utilisateur.
    }
  });
  return null;
}
